module.exports = __webpack_public_path__ + "img/7.30f41fd1.jpg";